import { vesselsData } from "./vesselData.js";
import axios from "axios";
import { ENDPOINT, SIGNATURE_TYPE } from "../../constants/endpoint.js";
import Swal from "sweetalert2";

var configWithToken = {
  headers: {
    "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
  },
};
const state = {
  resignationsPopup: null,
  resignations: null,
  headerData: null,
  statusData: [],
  amount: null,
  resignation: null
};

const mutations = {
  SET_RESIGNATION: (state, payload) => {
    state.resignations = payload;
  },
  SET_RESIGNATION_HEADER(state, payload) {
    state.headerData = payload;
  },
  SET_RESIGNATION_STATUS(state, payload) {
    state.statusData = payload;
  },
  SET_CHANGE_STATUS: (state, payload) => {
    const data = vesselsData;
    for (var i in data) {
      if (data[i].id == payload.id) {
        data[i].resignationStatus = payload.value;
        break;
      }
    }
    state.resignations = data;
    console.log("this is data resignation :", data);
  },
  SET_NUMBER_OF_RESIGNATION: (state, amount) => {
    state.amount = amount
  },
  SET_RESIGNATION_BY_ID: (state, resignation) => {
    state.resignation = resignation
  },
};

const actions = {
  deleteDocument: async ({ commit }, id) => {
    await axios.delete(`${ENDPOINT.DELETE_DOCUMENT_INSTALL}/${id}`).then((res) => {
      Swal.fire({
        icon: "success",
        title: "ลบเอกสารเรียบร้อยแล้ว",
        showConfirmButton: false,
        timer: 1500,
      }).then(() => {
      });
    }).catch(error => {
      const statusCode = error.response.data.statusCode;
      Swal.fire({
        icon: "warning",
        title: "เกิดข้อผิดพลาด",
        text: "กรุณาตรวจสอบความถูกต้อง",
        showConfirmButton: false,
        timer: 2000,
      });
    })

  },
  setResignations: async ({ commit }) => {
    const url = ENDPOINT.GET_VESSEL_RESIGNATIONS;
    console.log(url);
    await axios
      .get(`${url}`)
      .then((res) => {
        // console.log("data resign ", res.data[0].registration.createdBy);
        commit("SET_RESIGNATION", res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  },
  async setResignationHeader({ commit }, vesselId) {
    const url = ENDPOINT.GET_VESSEL_RESIGNATIONS;
    await axios
      .get(`${url}/vessel/${vesselId}`)
      .then((res) => {
        console.log("this is res data :", res.data);
        commit("SET_RESIGNATION_HEADER", res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  },
  setChangeStatus: ({ commit }, payload) => {
    commit("SET_CHANGE_STATUS", payload);
  },
  async getResignationStatus({ commit }, search) {
    const url = ENDPOINT.GET_VESSELS_STATUS;
    const config = {
      params: {
        ...search,
      },
    };
    await axios
      .get(url,config)
      .then((res) => {
        commit("SET_RESIGNATION_STATUS", res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  setResignationTable: async ({ commit }, data) => {
    console.log("this is data :", data);
    // console.log("this is data :", data.document);
    const formData = new FormData();
    formData.append("id", data.vesselId);
    formData.append("status", "ออกจากโครงการ");
    formData.append("resignationBy", "กรมสรรพสามิตพื้นที่");
    formData.append("createdByUserId", data.createdByUserId);
    formData.append("note", data.note);
    for (const document of data.document) {
      formData.append("files", document);
    }

    // console.log("data ", formData.getAll("status"));
    // console.log("files ", formData.getAll("files"));
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    };

    const url = ENDPOINT.CREATE_VESSEL_RESIGNATION_ADMIN;
    await axios
      .post(url, formData, config)
      .then( async(res) => {
        console.log("this is signature :",res.data.id);

        let sigantureForm = { 
          fileName: data.fileName,
          resignationId: res.data.id,
          type: SIGNATURE_TYPE.RESIGNATION
        }
        
        console.log("this is signature test form:", sigantureForm);
        const config = {
          headers: {
            // "content-type": "multipart/form-data",
            "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
          },
        };

        const createSignatureUrl = ENDPOINT.CREATE_SIGNATURE_BY_FILENAME
        await axios.post(createSignatureUrl , sigantureForm , config)
        .then((res) => {
          console.log("this is test test test test :",res);
        })
        .catch((error) =>{ 
          console.log("test eeoro eoeor ewoeor ",error);
        })
      })
      .catch((e) => {
        console.log(e);
      });
  },
  async setResignationStatus({ commit }, value) {
    const url = ENDPOINT.UPDATE_RESIGNATION_STATUS;
    const payload = {
      id: value.id,
      status: value.status,
    };
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    };
    await axios
      .put(url, payload, config)
      .then( async(res) => {
        console.log("this is res popopo :",res.data.id);

        const vessel = res.data.vessel

        if (payload.status == 'ออกจากโครงการ') {
            const notificationReq = {
              userId: res.data.resignationByUserId.id,
              title: "ออกจากโครงการ (ยืนยันการออกจากโครงการ)",
              body: `MMSI : ${vessel.mmsi}, เรือ : ${vessel.name}, ${vessel.zone.name} (${vessel.zone.branch})`
            }
            this.dispatch("notifications/sendNotificationToApplication", notificationReq)
        }

        let sigantureForm = { 
          fileName: value.fileName,
          resignationId: res.data.id, 
          type: SIGNATURE_TYPE.RESIGNATION
        }
        
        const config = {
          headers: {
            // "content-type": "multipart/form-data",
            "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
          },
        };

        const createSignatureUrl = ENDPOINT.CREATE_SIGNATURE_BY_FILENAME
        await axios.post(createSignatureUrl , sigantureForm , config)
        .then((res) => {
          console.log(res);
        })
        .catch((error) =>{ 
          console.log(error);
        })
      })
      .catch((err) => {
        console.log(err);
      });
  },
  async getNumberOfResignation({ commit }){
    const url = `${ENDPOINT.GET_NUMBER_OF_RESIGNATION}`;
    await axios
    .get(url,null,configWithToken)
    .then(async (response) => {
      const data = response.data;
      // console.log("data ", data);
      await commit("SET_NUMBER_OF_RESIGNATION", data);
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
    });
  },
  async getResignationById({ commit }, resignationId) {
    const url = ENDPOINT.GET_VESSEL_RESIGNATIONS + "/" + resignationId;
    await axios
      .get(url,null,configWithToken)
      .then((res) => {
        commit("SET_RESIGNATION_BY_ID", res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
